import React, { useContext } from 'react';
import c from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import { PopupContext } from '../../popups/PopupContext';
import s from './ModalLayout.scss';
/**
 * A modal layout with slots for a `header`, `content`, and `footer`.
 *
 * Note: If you need the slots separated by borders, consider using `<SegmentedModalLayout />`. They're separated for now
 * for safety down the road. There are too many possible modal designs to put all of these style options into one component.
 */
var ModalLayout = function (_a) {
    var header = _a.header, headerBorder = _a.headerBorder, preamble = _a.preamble, content = _a.content, footer = _a.footer, footerBorder = _a.footerBorder, className = _a.className, contentClassName = _a.contentClassName, footerClassName = _a.footerClassName, innerScrollRef = _a.innerScrollRef, _b = _a.withScrollableContentWrapper, withScrollableContentWrapper = _b === void 0 ? true : _b;
    var setDefaultScrollableRef = useContext(PopupContext).setDefaultScrollableRef;
    return (React.createElement(Section, { className: c(s['root'], className) },
        React.createElement("div", { className: c(s['header-and-preamble'], headerBorder && s['header-and-preamble-border']) },
            React.createElement("div", { className: s['header'] }, header),
            /** We expect the consumer to handle the layouting here */
            preamble),
        React.createElement("div", { className: c(s['content'], withScrollableContentWrapper && s['scrollable'], contentClassName), ref: function (node) {
                if (withScrollableContentWrapper) {
                    innerScrollRef && innerScrollRef(node);
                    // Set the default scrollable, see ModalRoot for the logic
                    setDefaultScrollableRef && setDefaultScrollableRef(node);
                }
            } }, content),
        footer && (React.createElement("div", { className: c(footerClassName, s['footer'], footerBorder && s['footer-border']) }, footer))));
};
ModalLayout.displayName = 'ModalLayout';
export default ModalLayout;
//# sourceMappingURL=ModalLayout.js.map